import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonIcon,
  IonInput
} from '@ionic/react'
import {
  close
} from 'ionicons/icons'
import YokIcon from '../../common/YokIcon'
import ReturnButton from '../ReturnButton'
import './styles.scss'

const Header = () => {
  const [showSearchBar, setToogleSearchBar] = useState(false)
  const [query, setQuery] = useState('')
  const live = useSelector(state => state.liveVideo.status === 'on-line')
  const history = useHistory()

  const toogleSearchBar = () => {
    setToogleSearchBar(!showSearchBar)
  }

  const handleKeyPress = (event) => {
    setQuery(event.target.value)
    if (event.key === 'Enter') {
      searchIt()
    }
  }

  const searchIt = () => {
    toogleSearchBar()
    const q = query
    setQuery('')
    history.push(`/busqueda/1?q=${q}`)
  }

  return (
    <IonHeader className='main-header'>
      <IonToolbar className='main-toolbar'>

        <ReturnButton />
        <IonButtons slot='start'>
          <IonButton
            onClick={toogleSearchBar}
            className='search-button'
            aria-label='Hacer una búsqueda'
          >
            <YokIcon name='xp-search' />
          </IonButton>
        </IonButtons>

        <Link
          className='brand-logo'
          to='/'
          aria-label='Ir a la página'
        >
          <YokIcon name='yok-hat' />
        </Link>

        {live &&
          <IonButtons slot='end'>
            <Link
              to='/live-video'
              aria-label='Ver transmisión en vivo'
            >
              <IonButton aria-label='Ver transmisión en vivo'>
                <YokIcon name='live' />
              </IonButton>
            </Link>
          </IonButtons>}
        <IonButtons slot='end'>
          <IonMenuButton />
        </IonButtons>

      </IonToolbar>

      <IonToolbar className={showSearchBar ? 'search-toolbar active' : 'search-toolbar'}>
        <IonButtons slot='start'>
          <IonButton
            onClick={searchIt}
            aria-label='Realizar búsqueda'
          >
            <YokIcon name='xp-search' />
          </IonButton>
        </IonButtons>
        <IonInput
          id='search-input'
          type='search'
          onKeyUp={handleKeyPress}
          value={query}
          aria-label='Introduce el texto que deseas buscar'
        />
        <IonButtons slot='end'>
          <IonButton
            onClick={toogleSearchBar}
            aria-label='Cerrar barra de búsqueda'
          >
            <IonIcon size='48' icon={close} />
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  )
}

export default Header
